<template>
  <a-card :bordered="false">
    <Breadcrumb routeName="PaySetting" toName="余额支付" goPathName="支付设置"></Breadcrumb>
    <a-form-model ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol" :model="ruleForm" :rules="rules"
                  style="margin-top: 30px">
      <a-form-model-item label="支付状态" :required="true">
        <a-switch checked-children="开" un-checked-children="关" default-checked disabled/>
      </a-form-model-item>
      <a-form-model-item label=" " :colon="false" :required="false">
        余额支付为默认的用户余额充值后使用的补充支付方式，目前禁止关闭！
      </a-form-model-item>
      <a-form-model-item label=" " :colon="false" :required="false">
        <a-button @click="backEvent" style="margin-left: 10px">返回</a-button>
      </a-form-model-item>
    </a-form-model>

  </a-card>
</template>

<script>
import formMixin from '../../utils/mixins/formMixins'
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import countDownHelper from '../../utils/helper/countDownHelper'

export default {
  name: 'BalancePaySetting',
  mixins: [formMixin],
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelCol: { span: 3 },
      wrapperCol: { span: 12 },
      ruleForm: {},
      rules: {}

    }
  },
  mounted() {  //重置  this.$refs.ruleForm.resetFields();
  },
  activated() {

  },
  methods: {}

}
</script>
<style lang="less" scoped>
.single-import-box {
  margin-top: 30px;

  .upload-box {
    margin-top: 14px;
    height: 104px;
    position: relative;
  }

  .selected-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: 104px;
  }

  .image-sample {
    position: absolute;
    top: 0;
    left: 200px;
    height: 104px;
  }

  .image-sample-1 {
    position: absolute;
    top: 0;
    left: 112px;
    height: 104px;
  }

  input {
    max-width: 400px;
  }

  .single-import-box > .ant-upload {
    width: 180px;
    height: 104px;
  }

  .picture-card .ant-upload-list-item {
    padding: 0;
  }
}

</style>